module.exports = __webpack_public_path__ + "img/Alien_symbol_6.65a9170e.png";